module.exports = __webpack_public_path__ + "static/media/icon_shiyongmianguang.31e45a4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/icon_shiyongmianguang.svg
// module id = 534
// module chunks = 0